import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { isPresent } from 'helpers/string_helpers';

import { endEmailGroup } from '../../store/actions/people';

export class PeopleEmailFormModal extends React.Component {

  static propTypes = {
    crmEmail: PropTypes.string,
    personEmailGroup: PropTypes.array,
    onCancelEmailGroup: PropTypes.func.isRequired
  };

  state = {
    copiedEmails: false
  }

  emails = () => {
    const { personEmailGroup } = this.props;
    return (personEmailGroup || []).length > 0 ? personEmailGroup.join(', ') : 'No emails selected';
  }

  handleCopy = () => {
    this.setState({ copiedEmails: true });
    navigator.clipboard.writeText(this.emails());
    setTimeout(() => {
      this.setState({ copiedEmails: false });
    }, 2000);
  }

  mailtoLink = () => {
    const { crmEmail, personEmailGroup } = this.props;
    if (personEmailGroup == null) return;

    let url = "";

    if (personEmailGroup.length === 1) {
      url = `mailto:${personEmailGroup[0]}`;
      if (isPresent(crmEmail)) url += `?bcc=${encodeURIComponent(crmEmail)}`;
    } else {
      url = `mailto:?bcc=${this.emails()}`;
      if (isPresent(crmEmail)) url += `, ${encodeURIComponent(crmEmail)}`;
    }

    return url;
  }

  render() {
    const { personEmailGroup, onCancelEmailGroup } = this.props;
    const disableButtons = (personEmailGroup || []).length < 1;

    return (
      <Modal centered show={personEmailGroup != null} size="lg" onHide={onCancelEmailGroup} onShow={this.handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>Email Selected Addresses</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{this.emails()}</p>
        </Modal.Body>
        <Modal.Footer className="text-start">
          <button className="btn btn-ghost" onClick={onCancelEmailGroup}>Cancel</button>
          <button className="btn btn-secondary" disabled={disableButtons} name="copyEmails" onClick={this.handleCopy}>
            {this.state.copiedEmails ? (
              <>
                <FontAwesomeIcon className="me-2" icon={faCheck} />Copied
              </>
            ) : (
              'Copy'
            )}
          </button>
          <a
            className="btn btn-primary"
            disabled={disableButtons}
            href={disableButtons ? null : this.mailtoLink()}
            name="sendEmail"
            rel="noopener noreferrer"
            target="_blank"
          >
            Send Email
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  crmEmail: state.static.crmEmail,
  personEmailGroup: state.people ? state.people.emailGroup : state.requirementsSet.emailGroup,
});

const mapDispatchToProps = {
  onCancelEmailGroup: endEmailGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleEmailFormModal);
